/**
 * Model for component Loader
 * @returns nothing
 */

class Model {
}

export default Model